export default __webpack_public_path__ + "static/media/td.ba4ff49b.svg";